import { useAuth } from '@trimble/trimble-id-solidjs';
import { Component, createEffect, JSX } from 'solid-js';

declare const aptrinsic: (...args: unknown[]) => void;

export const GainsightProvider: Component<{
  readonly children: JSX.Element;
}> = (props): JSX.Element => {
  const auth = useAuth();

  createEffect((): void => {
    if (auth().isAuthenticated && auth().user) {
      const user = auth().user;

      if (user != null) {
        aptrinsic('identify', {
          id: user.email, // Required for logged-in app users
          email: user.email,
          firstName: user.given_name,
          lastName: user.family_name,
          signUpDate: user.updated_at || Date.now(), // Unix time in ms
        });
      }
    }
  });

  return <>{props.children}</>;
};
